module.exports = __webpack_public_path__ + "img/iconuser.5921c32d.svg";